import { gql, useMutation } from "@apollo/client";

type TestResult = {
  success: boolean;
  httpStatusCode: number | null;
  errorMessage: string | null;
  responseTimeMs: number | null;
};

const TEST_NOTIFICATION_TRIGGER_API = gql`
  mutation testNotificationTriggerApi($triggerId: ID!) {
    testNotificationTriggerApi(triggerId: $triggerId) {
      success
      httpStatusCode
      errorMessage
      responseTimeMs
    }
  }
`;

export default function useTestNotificationTriggerApi() {
  const [mutate, { loading }] = useMutation<
    { testNotificationTriggerApi: TestResult },
    { triggerId: string }
  >(TEST_NOTIFICATION_TRIGGER_API);

  const testTrigger = async (triggerId: string) => {
    const result = await mutate({ variables: { triggerId } });
    return result.data?.testNotificationTriggerApi ?? null;
  };

  return [testTrigger, { loading }] as const;
}
